import apiConfig from "@/constants/apiConfig";
import { superAppActionTypes } from "../actions";
import { processCallbackAction } from "../helper";
import { takeLatest } from "redux-saga/effects";

const {
    GET_LIST,
    GET_DETAIL,
    UPLOAD_IMAGE,
    UPDATE_INFO,
    CREATE,
    UPDATE_STATUS,
    UPDATE_VERSION,
    EXPORT,
    GENERATE_TOKEN,
    UPDATE_PRIORITY,
    UPLOAD_BUNDLE,
} = superAppActionTypes;

const getList = (action) => {
    return processCallbackAction(apiConfig.superApp.getList, action);
};

const getDetail = ({ payload }) => {
    const { params, onCompleted, onError } = payload;
    const apiOptions = {
        ...apiConfig.superApp.getDetail,
        path: apiConfig.superApp.getDetail.path.replace(":id", params.id),
    };
    return processCallbackAction(apiOptions, {
        payload: { params: {}, onCompleted, onError },
    });
};

const uploadImage = (action) => {
    return processCallbackAction(apiConfig.superApp.uploadImage, action);
};

const uploadBundle = (action) => {
    return processCallbackAction(apiConfig.superApp.uploadBundle, action);
};

const updateInfo = (action) => {
    return processCallbackAction(apiConfig.superApp.updateInfo, action);
};

const updateVersion = (action) => {
    return processCallbackAction(apiConfig.superApp.updateVersion, action);
};

const updateStatus = (action) => {
    return processCallbackAction(apiConfig.superApp.updateStatus, action);
};

const create = (action) => {
    return processCallbackAction(apiConfig.superApp.create, action);
};

const exportExcel = (action) => {
    return processCallbackAction(apiConfig.superApp.exportExcel, action);
};

const generateToken = (action) => {
    return processCallbackAction(apiConfig.superApp.generateToken, action);
};

const updatePriority = (action) => {
    return processCallbackAction(apiConfig.superApp.updatePriority, action);
};

const superAppSagas = [
    takeLatest(GET_LIST, getList),
    takeLatest(GET_DETAIL, getDetail),
    takeLatest(UPLOAD_IMAGE, uploadImage),
    takeLatest(UPLOAD_BUNDLE, uploadBundle),
    takeLatest(UPDATE_INFO, updateInfo),
    takeLatest(UPDATE_VERSION, updateVersion),
    takeLatest(UPDATE_STATUS, updateStatus),
    takeLatest(CREATE, create),
    takeLatest(EXPORT, exportExcel),
    takeLatest(GENERATE_TOKEN, generateToken),
    takeLatest(UPDATE_PRIORITY, updatePriority),
];

export default superAppSagas;
